import React from 'react';
import { CategoryLink } from '@/sanity/fetchCategories';
import { URL_PAGE_ALWAYS, URL_PATH_CATEGORY } from '@/shared/constants';
import HIHLink from '@/components/base/Link';
import styles from './NavigationCategoriesList.module.scss';

interface NavigationCategoriesListProps {
  categories: CategoryLink[];
  isSubMenuOpen?: boolean;
  labelledBy: string;
  onCategoryClick: () => void;
}

const NavigationCategoriesList: React.FC<NavigationCategoriesListProps> = ({
  isSubMenuOpen,
  categories,
  labelledBy,
  onCategoryClick,
}) => {
  return (
    <ul aria-labelledby={labelledBy} className={styles.list}>
      {categories.slice(0, 7).map((category) => (
        <li key={category._id} className={styles.item}>
          <HIHLink
            onClick={onCategoryClick}
            href={`/${URL_PATH_CATEGORY}/${category.slug.current}`}
            className={styles.categoryLink}
            tabIndex={isSubMenuOpen ? 0 : -1}
          >
            {category.name}
          </HIHLink>
        </li>
      ))}
      {/*static Link to alle Themen*/}
      <li key={'AlleThemen'} className={styles.item}>
        <HIHLink
          onClick={onCategoryClick}
          href={URL_PAGE_ALWAYS + '#alleThemen'}
          className={styles.allTopicsLink}
          tabIndex={isSubMenuOpen ? 0 : -1}
        >
          Alle Themen →
        </HIHLink>
      </li>
    </ul>
  );
};

export default NavigationCategoriesList;
